<template>
  <div class="about">
		<div class="pg-header">
			<div><label class="title">{{tagName}}待随访</label></div>
			<div class="algr">
				<div class="pg-nav">
					<i class="icon-home"></i>
					<span>{{tagName}}随访管理</span>|
					<span>待随访</span>
				</div>
			</div>
		</div>

		<div class="collapse-wrap">
			<div class="search-bar">
				<el-form ref="form" label-width="120px">
					<div class="def-key">
						<label>姓名<el-input size="small" maxlength="6" style="width:80px" v-model.trim="filter.name" @keyup.enter.native="handleFilter(0, $event)"></el-input></label>
						<label>住院号<el-input size="small" maxlength="18" style="width:80px" v-model.trim="filter.admissionNumber" @keyup.enter.native="handleFilter(1, $event)"></el-input></label>
						<label>身份证号<el-input size="small" maxlength="18" style="width:150px" v-model.trim="filter.cardNum" @keyup.enter.native="handleFilter(1, $event)"></el-input></label>
						<div style="display: inline-block;">来源
							<el-select size="small" filterable clearable placeholder="请选择"
								v-model="filter.datasources" @change="handleFilter(4, $event)">
								<el-option label="出院" :value="Number(2)"></el-option>
								<el-option label="门诊" :value="Number(1)"></el-option>
							</el-select>
						</div>
						<!-- <label>联系电话<el-input size="small" maxlength="18" style="width:150px" v-model.trim="filter.phone" @keyup.enter.native="handleFilter(1, $event)"></el-input></label> -->
					</div>
					<div class="def-key">
						<label v-if="filter.datasources">
							{{
								filter.datasources?{1:'就诊',2:'出院'}[filter.datasources]:''
								}}日期
							<el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width:220px" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter.outdate" :picker-options="pickerOptions" @change="handleFilter(3, $event)"></el-date-picker>
						</label>
						<label>应随访日期
							<el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width:220px" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter.date" :picker-options="pickerOptions" @change="handleFilter(2, $event)"></el-date-picker>
						</label>
						<div style="margin-right:10px;">科室
							<el-select size="small" filterable clearable placeholder="请选择" multiple collapse-tags
								v-model="filter.selectedDepartmentIdList" @change="handleFilter(5, $event)"
								class="multiple-select">
								<el-option v-for="item in deptList" :key="item.id" :label="item.name"
									:value="item.id"></el-option>
							</el-select>
						</div>
						<label>诊断
							<el-input size="small" style="width:80px" v-model.trim="filter.outHospitalDiagnosisName" @keyup.enter.native="handleFilter(4, $event)"></el-input>
						</label>
					</div>
					<div class="def-key">
						<div style="display: inline-block;">随访次数
							<el-select size="small" filterable clearable placeholder="请选择"
								v-model="filter.currentFollowupNum" @change="handleFilter(4, $event)">
								<el-option label="1" value="1"></el-option>
								<el-option label="2" value="2"></el-option>
								<el-option label="3" value="3"></el-option>
								<el-option label="4" value="4"></el-option>
								<el-option label="5" value="5"></el-option>
								<el-option label="6" value="6"></el-option>
								<el-option label="7" value="7"></el-option>
								<el-option label="8" value="8"></el-option>
								<el-option label="9" value="9"></el-option>
								<el-option label="10" value="10"></el-option>
							</el-select>
						</div>
						<label>年龄
							<el-input size="small" style="width:80px" v-model.trim="filter.age" @keyup.enter.native="handleFilter(4, $event)"></el-input>
						</label>
						
						<el-button size="mini" icon="el-icon-search" round @click="handleFilter">搜索</el-button>
						<el-button class="btn-export" size="mini" round @click="exportReport"
							style="margin-right: 10px;"><i class="icon-export"></i>导出</el-button>
					</div>
				</el-form>
			</div>

			<div class="table-wrap">
				<el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border :data="list.data" v-loading="isLoading" @selection-change="selectionChange">
					<el-table-column prop="name" label="姓名" width="120" fixed="left">
						<template slot-scope="scope"><router-link class="noline" target="_blank" :to="{name: 'Patient/User', query: {patientId: scope.row.patientId, t:5, date: scope.row.date}}"><span class="fc key"><i class="icon-fav small" v-if="scope.row.star == 1"></i>{{ scope.row.name }}</span></router-link></template>
					</el-table-column>
					<el-table-column prop="departmentName" label="科室" width="140" show-overflow-tooltip></el-table-column>
					<el-table-column prop="admissionNumber" label="住院号" width="140" show-overflow-tooltip></el-table-column>
					<el-table-column prop="phone" label="联系电话" width="120" show-overflow-tooltip></el-table-column>
					<!-- 0822 隐藏begin -->
					<!-- <el-table-column prop="cardNum" label="身份证号" width="140"></el-table-column> -->
					<!-- <el-table-column label="性别" width="80">
						<template slot-scope="scope">
							<span v-if="scope.row.sex == 1">男</span>
							<span v-else>女</span>
						</template>
					</el-table-column>
					<el-table-column prop="age" label="年龄" width="80">
						<template slot-scope="scope">
							<span>{{scope.row.age}}岁</span>
						</template>
					</el-table-column> -->
					<!-- 0822 隐藏end -->
					<el-table-column prop="outHospitalDiagnosisName" width="140" label="诊断" show-overflow-tooltip></el-table-column>
					<el-table-column prop="docName" label="责任医师" width="120" show-overflow-tooltip></el-table-column>
					<el-table-column prop="" label="来源" width="80" show-overflow-tooltip>
						<template slot-scope="scope">
							<span v-if="scope.row.datasources == 0">院中</span>
							<span v-if="scope.row.datasources == 1">门诊</span>
							<span v-if="scope.row.datasources == 2">出院</span>						
						</template>
					</el-table-column>
					<el-table-column prop="age" label="年龄"></el-table-column>
					<el-table-column prop="outTimeDate"  :label="filter.datasources==1?'就诊时间':'出院时间'"  width="120" show-overflow-tooltip></el-table-column>
					<el-table-column prop="followupNum" label="随访次数"></el-table-column>
					<el-table-column prop="date" label="应随访日期" width="120" show-overflow-tooltip></el-table-column>
					<el-table-column prop="reviserName" label="排期人" width="120" show-overflow-tooltip></el-table-column>
					<el-table-column fixed="right" label="操作" width="160" show-overflow-tooltip>
						<template slot-scope="scope">
							<div class="tab-action">
								<el-tooltip content="随访" placement="top" :enterable="false"><router-link class="noline" target="_blank" :to="{name: 'Patient/User', query: {patientId: scope.row.patientId, t:5, date: scope.row.date}}"><i class="icon-follow"></i></router-link></el-tooltip>

								<el-tooltip content="终止随访" placement="top" :enterable="false"><i class="icon-wufan" @click="showDlg(1, scope.row)"></i></el-tooltip>	
							</div>
						</template>
					</el-table-column>
				</el-table>	
				<div class="pagination">
					<el-row>
						<el-col :span="12">
							<div class="record">当前是第<span v-text="(filter.pageNumber-1)*filter.pageSize+1"></span>条至第<span v-text="Math.min(list.total, (filter.pageNumber - 1) * filter.pageSize + filter.pageSize)"></span>数据</div>
							<div class="record">总计<span v-text="list.total"></span>条记录</div>
						</el-col>
						<el-col :span="12" style="text-align: right;">
							<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next" :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"  prev-text="上一页" next-text="下一页" :current-page="list.current" :page-size="filter.pageSize" :total="list.total" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
						</el-col>
					</el-row>
				</div>
			</div>				
				
		</div>

		<el-dialog title="终止随访" width="560px" :visible.sync="dlg.active" :close-on-click-modal="false">
			<el-form ref="form" label-width="120px" :rules="dlg.rules" :model="form">
				<el-form-item label="终止随访类型" prop="stopType">
					<el-radio-group v-model="form.stopType">
						<el-radio :label="1">单次终止</el-radio>
						<el-radio :label="2">全部终止</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="终止随访原因" prop="stopReason">
					<el-radio-group v-model="form.stopReason">
						<el-radio label="患者已住院">患者已住院</el-radio>
						<el-radio label="患者死亡">患者死亡</el-radio>
						<el-radio label="无法联系到患者">无法联系到患者</el-radio>
						<el-radio label="other">其他原因</el-radio>
						<el-input size="mini" placeholder="输入其他原因" style="width: 250px;" v-model="form.otherReason" v-if="form.stopReason == 'other'"></el-input>
					</el-radio-group>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button :loading="isLoading" @click="closeDlg">关 闭</el-button>
				<el-button type="primary" :loading="isLoading" @click="saveForm">保 存</el-button>
			</div>
		</el-dialog>

  </div>
</template>

<script>
import api from '@/service/api.js';
import utils from '@/service/utils';
import mixin from '@/views/mixin';
import dayjs from 'dayjs';

export default {
  mixins: [mixin],
	data(){
		return {
			dlg: {
				active: false,
				rules: {
					stopType: {required: true, message: '请选择'},
					stopReason: {required: true, message: '请选择'},
				}
			},
			list: {
				current: 1,
				total: 0,
				pageSize: 0,
				data: null
			},
			filter: {
				name: '',
				cardNum: '',
				expectFollowupDateStart: '',
				expectFollowupDateEnd: '',
				hospitalDepartmentId: '',
				outHospitalDiagnosisName: '',
				followupState: '1',
				date: [],
				pageNumber: 1,
				pageSize: 10,
				tagId:'',
				selectedDepartmentIdList:[],
				datasources:null
			},
			form: {id: 0, stopType: '', stopReason: '', otherReason: ''},
			deptList: [],
			tagName:''
		}
	},
	created() {
		let query = this.$route.query;
		this.filter.datasources=query.datasources?Number(query.datasources):null;

		if (query && query.t) {this.filter.followupState = `${query.t}`;}
		if(query.date){
			if (typeof(query.date)=='string') {
				this.filter.expectFollowupDateStart = dayjs(query.date).format('YYYY-MM-DD 00:00:00')
				this.filter.expectFollowupDateEnd = dayjs(query.date).format('YYYY-MM-DD 23:59:59');
				this.filter.date = [this.filter.expectFollowupDateStart, this.filter.expectFollowupDateEnd];
			}else{
				
				this.filter.expectFollowupDateStart = dayjs(query.date[0]).format('YYYY-MM-DD 00:00:00')
				this.filter.expectFollowupDateEnd = dayjs(query.date[1]).format('YYYY-MM-DD 23:59:59');
				this.filter.date = [this.filter.expectFollowupDateStart, this.filter.expectFollowupDateEnd];
			}

		}
		if(query.date2){
			this.filter.outHospitalTimeStart = dayjs(query.date2[0]).format('YYYY-MM-DD 00:00:00')
				this.filter.outHospitalTimeEnd = dayjs(query.date2[1]).format('YYYY-MM-DD 23:59:59');
				this.filter.outdate = [this.filter.outHospitalTimeStart, this.filter.outHospitalTimeEnd];
		}
		// 0531 新增 tagId筛选
		this.filter.tagId=query.tagId?query.tagId:'';
		this.filter.selectedDepartmentIdList=query.depId?[Number(query.depId)]:'';
		this.$watch(
			() => this.$route.query, // 监听的对象是 $route.query
			(newQuery, oldQuery) => {
				this.tagName='';
				this.filter={
					name: '',
					cardNum: '',
					expectFollowupDateStart: '',
					expectFollowupDateEnd: '',
					hospitalDepartmentId: '',
					outHospitalDiagnosisName: '',
					followupState: '1',
					date: [],
					pageNumber: 1,
					pageSize: 10,
					tagId:newQuery.tagId?newQuery.tagId:'',
					selectedDepartmentIdList:newQuery.depId?[Number(newQuery.depId)]:[],
					datasources:newQuery.datasources?Number(newQuery.datasources):null,
				}
				this.loadList();
			}
		);
		
		this.loadList();
		// 获取 科室下拉
		api.getDeptDropdown({}).then((res)=>{
			if (res.code == 1000 && res.data) {
				this.deptList = res.data;
			}
		})
	},
	mounted() {
		// 监听页面显示隐藏
		document.addEventListener('visibilitychange', this.handleVisiable);
		// let callState=localStorage.getItem('callState');
		// if(callState){
		// 	localStorage.removeItem('callState');
		// }
	},  
	destroyed() {  
		document.removeEventListener('visibilitychange', this.handleVisiable)  
	},
	methods: {
		async loadList() {
			console.log(this.filter.selectedDepartmentIdList,'----------------')
			this.isLoading = true;
			if (this.filter.selectedDepartmentIdList) {
				this.filter.hospitalDepartmentIds = this.filter.selectedDepartmentIdList.join(',');
			}
			let res = await api.getFollowList(this.filter);
			if (res.code == 500) {return this.$router.push({name: 'Login', query: {r: location.href}});}

			this.list.total = +res.total;
			this.list.current = this.filter.pageNumber;
			this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
			if (res.data) {
				res.data.forEach((item)=>{
					item.date = dayjs(item.expectFollowupDate).format('YYYY-MM-DD');
					item.cardNum = utils.hideIdCard(item.cardNum);
					item.phone = utils.hidePhone(item.phone);
				})
				this.list.data = res.data;
			}
			// 0530 新增
			if(this.filter.tagId != ''){
				let res2 = await api.getTag(this.filter.tagId);
				if (res2.code == 1000 && res2.data) {
					this.tagName = res2.data.name;
				}
			}
			this.isLoading = false;
		},
		// 终止随访
		async saveForm() {
			this.$refs['form'].validate(async (valid)=>{
				if (valid) {
					let form = JSON.parse(JSON.stringify(this.form));
					if (form.stopReason == 'other') {form.stopReason = form.otherReason;}
					if (form.stopReason == '') {return this.$message.warning('请输入终止原因')}
					this.isLoading = true;
					let res = await api.stopFollow(form);
					this.isLoading = false;
					if (res.code != 1000) {
						return this.$message.error(res.message);
					}
					this.$message.success('保存成功');
					this.closeDlg();
					this.loadList();
				}
			})
		},
		showDlg(v, item) {
			this.dlg.active = true;
			this.$nextTick(()=>{
				this.$refs['form'].resetFields();
				this.form.id = item.id;
			});			
		},
		closeDlg() {
			this.dlg.active = false;
		},
		handleTab(tab){
			// 切换列表类型
			switch(tab.name) {
				case '1': this.$router.push({name: 'Follow', query: {t:1}}); break;
				case '3': this.$router.push({name: 'Follow', query: {t:3}}); break;
			}			
			this.loadList();
		},
		// 过滤条件 更改
		handleFilter(key, val) {
			switch(key) {
				case 2:
					if (this.filter.date) {
						this.filter.expectFollowupDateStart = dayjs(this.filter.date[0]).format('YYYY-MM-DD 00:00:00');
						this.filter.expectFollowupDateEnd = dayjs(this.filter.date[1]).format('YYYY-MM-DD 23:59:59');
					} else {
						this.filter.expectFollowupDateStart = '';
						this.filter.expectFollowupDateEnd = '';						
					}
					break;
				case 3:
					if (this.filter.outdate) {
						this.filter.outHospitalTimeStart = dayjs(this.filter.outdate[0]).format('YYYY-MM-DD 00:00:00');
						this.filter.outHospitalTimeEnd	 = dayjs(this.filter.outdate[1]).format('YYYY-MM-DD 23:59:59');
					} else {
						this.filter.outHospitalTimeStart = '';
						this.filter.outHospitalTimeEnd = '';						
					}
					break;
				case 5:
					if (this.filter.selectedDepartmentIdList) {
						this.filter.hospitalDepartmentIds = this.filter.selectedDepartmentIdList.join(',');
					} else {
						this.filter.updateDateStart = '';
						this.filter.updateDateEnd = '';
					}
					break;
			}
			this.filter.pageNumber = 1;
			this.loadList();
		},			
		handleSizeChange(v) {
			this.filter.pageSize = v;
			this.filter.pageNumber = 1;
			this.loadList();
		},
		handleCurrentChange(v) {
			this.filter.pageNumber = v;
			this.loadList();
		},
		handleVisiable(e){
			// 关闭新开页面，回到列表页，刷新列表数据
			if(e.target.visibilityState == "visible"){
				this.loadList()
			}
		},
		exportReport() {
			this.filter.pageSize=this.list.total;
			let url = api.exportFollowup2ByObject(this.filter);
			const tempLink = document.createElement('a');
			tempLink.style.display = 'none';
			tempLink.href = url;
			tempLink.target = '_blank';
			document.body.appendChild(tempLink);
			tempLink.click()
			document.body.removeChild(tempLink);
			this.filter.pageSize=10;

		}			
	}
}
</script>

<style lang="less" scoped>
@import '@/assets/style/var';
.search-bar{
	.multiple-select{
		/deep/ .el-input{
			width: 250px;
			margin:0;
		}
	}
}
</style>
